/**
 * Throw an error if the checked value is null/undefined.
 * 
 * @param {Object} value - The value to check
 * @param {String} what - Description to include in thrown error
 * @returns The checked value
 * @throws An error if value is null or undefined
 */
function requireNonNull(value, what) {
    if (typeof value === 'undefined' || value === null) {
        throw new Error(what + " is null");
    }
    
    return value;
}

module.exports = requireNonNull;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/util/require-non-null.js
// module id = 61
// module chunks = 1